module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two-b_quote@2x.829604e7.jpg";